import React from "react";
import "./style/apropos.css"
import img from "../assets/apropos/triangle.png"


class Apropos extends React.Component {

  render() {
    return (
      <div>
         <div style={{ "zIndex": "1"}}>
              <img style={{marginTop: "-6%" }} src={img} className="triangleImage" alt="" />
         </div>
        <div className="flex-container-apropos-Resp">

          <div className="divImg">
           
            <div className="divTitle">
              <div className="divTitleApropos">
                <h1 className="title">À PROPOS<br/>DE CHIFCO</h1>
              </div>
            </div>
          </div>

          <div className="divParag">
          <p className="partenaireTech">VOTRE PARTENAIRE TECHNOLOGIQUE, POUR UN MONDE MEILLEUR ET PLUS SMART</p>
            <p className="positionParagraph">
              {/* <b style={{ color: "#3d3d3d", fontFamily: "Oswald", fontSize: "20px" , lineHeight: "22px" }}>VOTRE PARTENAIRE TECHNOLOGIQUE, POUR UN MONDE MEILLEUR ET PLUS SMART</b><br /> */}
              Créée en Août 2011, Chifco est une entreprise tunisienne spécialisée dans le domaine de l’Internet des Objets,
              le Machine Learning, le Big Data et la Business Intelligence. Basée à Sousse, Tunis et Paris,
              Chifco se destine à devenir un acteur majeur dans la région EMEA dans la création de solutions
              technologiques à forte valeur ajoutée pour ses partenaires Business.
            </p>
          </div>
        </div>
      </div>
    );
  }
}
export default Apropos;





// WEBPACK FOOTER //
// ./src/home/apropos.js